import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import MUIRichTextEditor from 'mui-rte'
import { markdownToDraft } from 'markdown-draft-js'
import editorStateToMarkdown from 'lib/rte-utils/editor-state-to-markdown'
import clsx from 'clsx'
import { useStyles as useFlowStyles } from 'pages/pga-coach/bookings/events/edit/edit-event-form/styles'
import useStyles from '../styles'

const CONTROLS = ['bold', 'italic', 'strikethrough', 'bulletList', 'link']

export default function MessageEditor({
  value,
  placeholder,
  onChange,
  editorRef,
}) {
  const flowClasses = useFlowStyles()
  const classes = useStyles()
  const defaultValue = useRef(JSON.stringify(markdownToDraft(value || '')))
  const latest = useRef(value)

  const handleChange = editorState => {
    // Selection and focus changes also reach here; only real edits sync.
    if (!editorState.getLastChangeType()) return
    const markdown = editorStateToMarkdown(editorState)
    if (markdown === latest.current) return
    latest.current = markdown
    onChange(markdown)
  }

  return (
    <div
      className={clsx(flowClasses.editorRoot, classes.messageEditor)}
      data-testid="campaign-message-editor"
    >
      <MUIRichTextEditor
        ref={editorRef}
        className={flowClasses.editor}
        label={placeholder}
        controls={CONTROLS}
        defaultValue={defaultValue.current}
        onChange={handleChange}
      />
    </div>
  )
}

MessageEditor.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  editorRef: PropTypes.shape({ current: PropTypes.any }),
}
